import React, { useState } from 'react';
import { CloseButton } from '@components/CloseButton';
import { CountrySelectorFooter } from './CountrySelectorFooter';
import classNames from 'classnames';

interface Link {
  Text: string;
  Href: string;
  Target: string | null;
  PageId: number;
}

interface MobileListProps {
  title: string;
  countries: Array<{
    Text: string;
    Href: string;
  }>;
  countrySelectList: {
    ContactUsPageLink: Link;
    I18n: Record<string, string>;
    RedirectedIntro: string;
    RemoveSettingsText: string;
  };
}

export const MobileList = ({ countries, title, countrySelectList }: MobileListProps) => {
  const [isCountrySelector, setIsCountrySelector] = useState(false);

  const selectCountryMobile = (e) => {
    document.location.href = e.target.value;
  };

  const openCountrySelector = () => {
    setIsCountrySelector(true);
  };

  const closeCountrySelector = () => {
    setIsCountrySelector(false);
  };

  return (
    <>
      <div className='l-header-market-area'>
        {isCountrySelector && (<div className='market-overlay'></div>)}
        <div className='l-header-market-heading'>{title}</div>
        <div
          className='l-header-market-selector c-accordion-tabs-head-countryselect'
          onClick={openCountrySelector}
        >
          <i className='icon-sphere'></i>
          <div className='market-language'>{window.lang.toUpperCase()}</div>
          <i className='icon-angle-right market-arrow'></i>
        </div>
      </div>
      {isCountrySelector && (
        <div className='c-country-selector-block-mobile'>
          <div className='c-country-selector-header-mobile'>
            {title}
            <span>
              <CloseButton className='c-close-button' onClick={closeCountrySelector} />
            </span>
          </div>
          <ul className='c-country-selector-block-mobile-content'>
            {countries.map((element, index) => (
              <li key={index} className='c-country-selector-mobile-list'>
                <a onClick={selectCountryMobile} href={element.Href}>
                  {element.Text}
                </a>
              </li>
            ))}
          </ul>
          <CountrySelectorFooter
            footerLink={countrySelectList.ContactUsPageLink.Text}
            footerText={countrySelectList.I18n.ContactUsPageText}
            footerLinkHref={countrySelectList.ContactUsPageLink.Href}
            RedirectedIntro={countrySelectList.RedirectedIntro}
            RemoveSettingsText={countrySelectList.RemoveSettingsText}
          />
        </div>
      )}
    </>
  );
};
